import * as React from "react";
import type { SVGProps } from "react";
const SvgDoneCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10 17.5A7.5 7.5 0 0 1 2.5 10v0A7.5 7.5 0 0 1 10 2.5v0a7.5 7.5 0 0 1 7.5 7.5v0a7.5 7.5 0 0 1-7.5 7.5"
      clipRule="evenodd"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m13.333 8.334-4.167 4.167-2.5-2.5"
    />
  </svg>
);
export default SvgDoneCheck;
